import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom'
import {
  Table, Tag, Space, Card, Popconfirm, Spin, Row, Col,
  Form, DatePicker, Select, InputNumber, Button, Pagination,
  Alert, Statistic, Divider, Typography, Tooltip
} from 'antd';
import {
  LoadingOutlined, DeleteOutlined, EditOutlined,
  CrownOutlined, InfoCircleOutlined, ArrowUpOutlined, ArrowDownOutlined
} from '@ant-design/icons';
import FormModal from '../components/modalDepotForm'
import FormClientModal from '../../customers/components/FormModal';
import axios from '../../services/axios'
import SelectSearchInput from '../../utils/components/selectSearchInput';
import DatePickerCustom from '../../utils/components/datePicker';
import moment from 'moment';
import { getNomItineraire } from '../../utils/constants/pays';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface IProps {
  pagination: {
    pageSize: Number,
    current: Number
  }
}

// ✅ NOUVEAU: Interface pour le solde VIP
interface VipBalance {
  solde: number;
  devise: string;
  client_id: number;
  type_solde: 'credit_client' | 'dette_client' | 'equilibre';
}

const Depot = () => {
  const { id }: any = useParams()
  const [visible, setVisible] = React.useState(false);
  const [visibleClient, setVisibleClient] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [redirect, setRedirect] = React.useState(false)
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 100
  });
  const [loading, setLoading] = React.useState(false);
  const [devises, setDevises] = React.useState([])
  const [clients, setClients] = React.useState([])
  const [sumDepotByDevise, setSumDepotByDevise] = React.useState({})
  const [defaultValue, setDefaultValue] = React.useState({})
  const [dateStart, setDateStart] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [idDevise, setIdDevise] = React.useState(null)

  // ✅ NOUVEAU: États pour la logique VIP
  // selectedClientIsVip : indique si le client actuellement sélectionné est VIP
  const [selectedClientIsVip, setSelectedClientIsVip] = React.useState(false);
  // vipBalance : solde actuel du client VIP en devise d'entrée
  const [vipBalance, setVipBalance] = React.useState<VipBalance | null>(null);
  // vipBalanceLoading : indicateur de chargement lors de la récupération du solde VIP
  const [vipBalanceLoading, setVipBalanceLoading] = React.useState(false);
  // selectedClientId : ID du client sélectionné dans le formulaire (mis à jour par le modal)
  const [selectedClientId, setSelectedClientId] = React.useState<number | null>(null);
  // selectedDeviseEntree : code de la devise d'entrée sélectionnée dans le formulaire
  const [selectedDeviseEntree, setSelectedDeviseEntree] = React.useState<string | null>(null);

  const [form] = Form.useForm();

  React.useEffect(() => {
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');

    fetchData({ pagination } as IProps);
    getDevise()
    getClient()
    getSumDepotByDevise(dateFormated, dateFormated)
  }, [])

  // On récupère automatiquement son solde pour l'afficher dans le formulaire.
  React.useEffect(() => {
    if (selectedClientIsVip && selectedClientId && selectedDeviseEntree) {
      fetchVipBalance(selectedClientId, selectedDeviseEntree);
    } else {
      setVipBalance(null);
    }
  }, [selectedClientIsVip, selectedClientId, selectedDeviseEntree]);

  const getRandomuserParams = (params: any) => ({
    results: params.pagination.pageSize,
    page: params.pagination.current,
    ...params,
  });

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    fetchData({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters,
    });
  };

  const getsetClient = () => {
    setVisibleClient(true)
  }

  const getClient = () => {
    axios.get('/clients')
        .then(response => {
          setClients(response.data);
          setLoading(false)
        });
  }

  const fetchData = (params: any) => {
    setLoading(true);
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');
    axios.get(`/operations/type/depot/${dateFormated}/${dateFormated}`)
        .then(response => {
          setData(response.data)
          setLoading(false)
        });
  };

  const getDevise = () => {
    axios.get('/devises')
        .then(response => {
          setDevises(response.data);
          setLoading(false)
        });
  }

  const getSumDepotByDevise = (start: any, end: any) => {
    axios.get(`/operations/rapport/sum-depot/by-devise/${start}/${end}`)
        .then(response => {
          setSumDepotByDevise(response.data);
          setLoading(false)
        });
  }

  // ✅ NOUVEAU: Récupération du solde VIP du client en devise d'entrée.
  // Endpoint backend: GET /operations/vip-balance/{clientId}/{deviseCode}
  const fetchVipBalance = (clientId: number, deviseCode: string) => {
    setVipBalanceLoading(true);
    axios.get(`/operations/vip-balance/${clientId}/${deviseCode}`)
        .then(response => {
          setVipBalance(response.data);
          setVipBalanceLoading(false);
        })
        .catch(() => {
          // Pas de solde trouvé = solde zéro, pas bloquant
          setVipBalance({ solde: 0, devise: deviseCode, client_id: clientId, type_solde: 'equilibre' });
          setVipBalanceLoading(false);
        });
  };

  // ✅ NOUVEAU: Handler appelé par FormModal quand le client change.
  // On vérifie si le client sélectionné est VIP et on met à jour l'état.
  const handleClientChange = (clientId: number) => {
    setSelectedClientId(clientId);
    const client: any = clients.find((c: any) => c.id === clientId);
    if (client) {
      const isVip = Boolean(client.isVip || client.is_vip);
      setSelectedClientIsVip(isVip);
      if (!isVip) {
        // Réinitialiser le solde VIP si le client n'est pas VIP
        setVipBalance(null);
      }
    }
  };

  // ✅ NOUVEAU: Handler appelé par FormModal quand la devise d'entrée change.
  const handleDeviseEntreeChange = (deviseCode: string) => {
    setSelectedDeviseEntree(deviseCode);
  };

  const getSingleOperation = (id: number) => {
    setVisible(true);
    axios.get(`/operations/${id}`)
        .then(response => {
          form.setFieldsValue(response.data)
          setDefaultValue(response.data)
          setLoading(false)
        })
        .catch(error => {
          console.log('error not found', error);
        });
  }

  // ✅ MODIFIÉ: onCreate intègre maintenant les données VIP dans la requête.
  // Les champs `montant_supplementaire` et `is_vip_client` sont ajoutés si le client est VIP.
  const onCreate = (values: any) => {
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');
    setConfirmLoading(true);

    // Construction du payload en ajoutant les champs VIP si applicable
    const payload = {
      ...values,
      // ✅ NOUVEAU: Indique au backend que c'est une transaction VIP
      is_vip_client: selectedClientIsVip,
      // ✅ NOUVEAU: Montant supplémentaire saisi par l'opérateur (positif = crédit pris, négatif = crédit donné)
      // Si le client n'est pas VIP ou si le champ n'est pas rempli, on envoie 0
      montant_supplementaire: selectedClientIsVip ? (values.montant_supplementaire ?? 0) : 0,
    };

    axios.post('/operations/new', payload)
        .then(function (response) {
          setLoading(false);
          setRedirect(true)
          fetchData(Pagination)
          getSumDepotByDevise(dateFormated, dateFormated)
          setConfirmLoading(false);
          setVisible(false);
          form.resetFields();
          // ✅ NOUVEAU: Réinitialiser l'état VIP après la transaction
          setSelectedClientIsVip(false);
          setVipBalance(null);
          setSelectedClientId(null);
          setSelectedDeviseEntree(null);
        })
        .catch(function (error) {
          console.log(error);
          setConfirmLoading(false);
          setLoading(false);
        });
  };

  const onClientCreate = (values: any) => {
    axios.post('/clients/new', values)
        .then(function (response) {
          getClient()
          setLoading(false);
          form.resetFields();
          setVisibleClient(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
        });
  };

  const onChange = (name: string, value: any) => {
    form.setFieldsValue({ [name]: value })
    setIdDevise(value);
    setLoading(true)
    axios.get(`/operations/type/depot/${dateStart}/${dateEnd}/${value}`)
        .then(response => {
          setData(response.data)
          setLoading(false)
        });
  }

  function onSearch(val: string) {}

  const handleOk = (id: number) => {
    setLoading(true)
    axios.delete(`/operations/delete/${id}`)
        .then(response => {
          axios.get(`/operations/type/depot/${dateStart}/${dateEnd}`)
              .then(response => {
                setData(response.data)
                getSumDepotByDevise(dateStart, dateEnd)
                setLoading(false)
              });
          setLoading(false)
        });
  };

  const handleCancel = () => {};

  const renderCustomCell = (item: any, name: string) => {
    if (name == 'client') {
      const { client } = item;
      const clients = client.prenom + ' ' + client.nom + '/' + client.telephone
      return clients;
    } else if (name == 'devise') {
      const { devise } = item
      return devise.code
    }
  };

  const getTypePaiementDisplay = (type_paiement: string) => {
    const typeConfig: any = {
      'espece':        { label: 'Espèce',       color: 'green' },
      'virement':      { label: 'Virement',      color: 'blue' },
      'depot_mobile':  { label: 'Dépôt mobile',  color: 'orange' },
      'cheque':        { label: 'Chèque',         color: 'purple' }
    };
    return typeConfig[type_paiement] || { label: 'Espèce', color: 'green' };
  };

  // ✅ NOUVEAU: Rendu du badge VIP dans le tableau
  const renderClientCell = (record: any) => {
    const { client } = record;
    const isVip = Boolean(client.isVip || client.is_vip);
    const clientStr = client.prenom + ' ' + client.nom + '/' + client.telephone;
    return (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
        {clientStr}
          {isVip && (
              <Tooltip title="Client VIP">
                <CrownOutlined style={{ color: '#faad14', marginLeft: 6 }} />
              </Tooltip>
          )}
      </span>
    );
  };

  // ✅ NOUVEAU: Rendu du montant supplémentaire VIP dans le tableau
  const renderMontantSupplementaire = (record: any) => {
    const supp = record.montant_supplementaire;
    if (!supp || supp === 0) return <Tag color="default">-</Tag>;
    if (supp > 0) {
      return (
          <Tooltip title="Crédit pris par le client">
            <Tag color="red" icon={<ArrowDownOutlined />}>
              -{parseFloat(supp).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {record.devise?.code}
            </Tag>
          </Tooltip>
      );
    }
    return (
        <Tooltip title="Crédit laissé par le client">
          <Tag color="green" icon={<ArrowUpOutlined />}>
            +{parseFloat(Math.abs(Number(supp)).toFixed()).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {record.devise?.code}
          </Tag>
        </Tooltip>
    );
  };

  let i = 0;
  const columns = [
    {
      title: "N°",
      key: "index",
      render: (row: any, value: any, index: number = 0) => <>{index + 1}</>,
    },
    {
      title: 'Date',
      dataIndex: 'date_operation',
      key: 'date_operation'
    },
    {
      title: 'N° reçu',
      dataIndex: 'numero_recu',
      key: 'numero_recu'
    },
    {
      title: 'Client',
      key: 'client',
      width: 200,
      // ✅ MODIFIÉ: Utilise renderClientCell pour afficher l'icône VIP
      render: (record: any) => renderClientCell(record),
    },
    {
      title: 'Déposant',
      key: 'nom_deposant',
      render: (nom_deposant: number, row: any) => (
          <>{row.nom_deposant ? (row.nom_deposant + ' ' + row.tel_deposant) : 'Par le client lui même'}</>
      ),
    },
    {
      title: 'Départ',
      dataIndex: 'pays_depart',
      key: 'pays_depart',
      render: (pays_depart: string) => <Tag color="cyan">{getNomItineraire(pays_depart)}</Tag>,
    },
    {
      title: 'Récupération',
      dataIndex: 'pays_recuperation',
      key: 'pays_recuperation',
      render: (pays_recuperation: string) => <Tag color="geekblue">{getNomItineraire(pays_recuperation)}</Tag>,
    },
    {
      title: 'Type de paiement',
      dataIndex: 'type_paiement',
      key: 'type_paiement',
      render: (type_paiement: string) => {
        const config = getTypePaiementDisplay(type_paiement);
        return <Tag color={config.color}>{config.label}</Tag>;
      },
    },
    {
      title: 'Motif',
      dataIndex: 'motif',
      key: 'motif',
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      align: 'right',
      key: 'montant',
      render: (montant: any, record: any) => (
          <Tag>{parseFloat(montant).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + record.devise.code}</Tag>
      ),
    },
    {
      title: 'Taux',
      dataIndex: 'taux',
      align: 'center',
      key: 'taux',
      render: (montant: any, row: any) => (
          <Tag>{parseFloat(montant).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</Tag>
      ),
    },
    {
      title: 'Montant Converti',
      dataIndex: 'montant_sortie',
      align: 'right',
      key: 'montant_sortie',
      render: (montant: any, row: any) => (
          <Tag color='blue'>
            {parseFloat(montant).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + row.devisesortie.code}
          </Tag>
      ),
    },
    // ✅ NOUVEAU: Colonne affichant le crédit/dette VIP de l'opération
    {
      title: (
          <Tooltip title="Montant de crédit pris (+) ou laissé (-) par un client VIP">
            Crédit VIP <InfoCircleOutlined />
          </Tooltip>
      ),
      key: 'montant_supplementaire',
      render: (record: any) => renderMontantSupplementaire(record),
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id: any, row: any) => (
          <Button title="Editer">
            <Link style={{ marginRight: 10 }} to={`/depot/edit/${id}`}><EditOutlined /></Link>
          </Button>
      )
    },
  ];

  const onDateChange = (dates: any, dateStrings: any) => {
    setLoading(true)
    setDateStart(dateStrings[0])
    setDateEnd(dateStrings[1])
    if (idDevise) {
      axios.get(`/operations/type/depot/${dateStrings[0]}/${dateStrings[1]}/${idDevise}`)
          .then(response => {
            setData(response.data)
            setLoading(false)
          });
    } else {
      axios.get(`/operations/type/depot/${dateStrings[0]}/${dateStrings[1]}`)
          .then(response => {
            setData(response.data)
            setLoading(false)
          });
    }
    getSumDepotByDevise(dateStrings[0], dateStrings[1])
  }

  // ✅ NOUVEAU: Rendu du panneau d'informations VIP affiché au-dessus du tableau
  // quand on ouvre le modal et qu'un client VIP est sélectionné.
  // Ce panneau est exporté comme prop vers FormModal pour être affiché dans le modal.
  const renderVipInfoPanel = () => {
    if (!selectedClientIsVip) return null;
    if (vipBalanceLoading) return <Spin size="small" />;
    if (!vipBalance) return null;

    const solde = vipBalance.solde;

    // Cas 1 : solde équilibré
    if (solde === 0) {
      return (
          <Alert
              message={<><CrownOutlined style={{ color: '#faad14' }} /> Client VIP - Aucun solde en attente</>}
              type="info"
              showIcon={false}
              style={{ marginBottom: 12 }}
          />
      );
    }

    // Cas 2 : solde > 0 = on doit de l'argent au client → il va récupérer son dû + sa transaction
    if (solde > 0) {
      return (
          <Alert
              message={
                <span>
              <CrownOutlined style={{ color: '#faad14' }} />
                  {' '}Client VIP — <Text strong style={{ color: '#52c41a' }}>
                Crédit dû: {solde.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {vipBalance.devise}
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Ce montant sera automatiquement ajouté à sa transaction (il récupérera plus).
              </Text>
            </span>
              }
              type="success"
              style={{ marginBottom: 12 }}
          />
      );
    }

    // Cas 3 : solde < 0 = le client nous doit → on déduit de sa transaction
    return (
        <Alert
            message={
              <span>
            <CrownOutlined style={{ color: '#faad14' }} />
                {' '}Client VIP — <Text strong style={{ color: '#ff4d4f' }}>
              Dette: {Math.abs(solde).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {vipBalance.devise}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              Ce montant sera automatiquement déduit de sa transaction (il récupérera moins).
            </Text>
          </span>
            }
            type="warning"
            style={{ marginBottom: 12 }}
        />
    );
  };

  return <>
    <Card
        size="small"
        title={<h4>Liste des Dépots</h4>}
        extra={
          <Button type="primary" onClick={() => setVisible(true)}>
            Nouveau
          </Button>
        }
    >
      <Row justify='end'>
        <Form layout='inline'>
          <Form.Item label="Dates">
            <DatePickerCustom onChange={onDateChange} />
          </Form.Item>
          <Form.Item label='Devise'>
            <SelectSearchInput
                onChange={(v) => onChange('devise', v)}
                onSearch={(value) => onSearch(value)}
                data={devises}
                label='code'
                valueLabel='id'
                placeholder="Selectionnez la devise d'entre"
            />
          </Form.Item>
        </Form>
      </Row>
      <br />
      <br />

      <Table
          columns={columns as any}
          rowKey={(record: any) => record.login}
          dataSource={data}
          pagination={{ pageSize: 100 }}
          loading={loading}
          scroll={{ x: 'max-content' }}
          // ✅ NOUVEAU: Ligne VIP colorée en doré pour les distinguer visuellement
          rowClassName={(record: any) =>
              (record.client?.isVip || record.client?.is_vip) ? 'vip-row' : ''
          }
      />

      <Row justify='end'>
        {
          Object.entries(sumDepotByDevise).map(
              (val, index) => (
                  <Col xs={12} sm={8} md={6} lg={4} key={index}>
                    <Form.Item label={`Total en ${val[0]}`}>
                      <InputNumber
                          disabled
                          value={val[1] as number}
                          style={{ width: '100%', fontSize: 15 }}
                          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Col>
              )
          )
        }
      </Row>

      <FormModal
          visible={visible}
          setClientVisible={getsetClient}
          onCreate={onCreate}
          devises={devises}
          clients={clients}
          defaultVal={defaultValue}
          loading={confirmLoading}
          onCancel={() => {
            setVisible(false);
            setSelectedClientIsVip(false);
            setVipBalance(null);
            setSelectedClientId(null);
            setSelectedDeviseEntree(null);
          }}
          // ✅ NOUVEAU: Props VIP passées à FormModal
          isVipClient={selectedClientIsVip}
          vipBalance={vipBalance}
          vipBalanceLoading={vipBalanceLoading}
          onClientChange={handleClientChange}        // Callback quand client change dans le modal
          onDeviseEntreeChange={handleDeviseEntreeChange} // Callback quand devise d'entrée change
      />

      <FormClientModal
          visible={visibleClient}
          onCreate={onClientCreate}
          onCancel={() => setVisibleClient(false)}
      />
    </Card>

    {redirect ? (<Navigate to="/depot/" replace />) : ''}

    {/*
      ✅ NOUVEAU: Style VIP - à placer dans ton fichier CSS global ou dans un <style> tag.
      Les lignes de clients VIP auront un fond doré subtil.

      .vip-row {
        background-color: #fffbe6 !important;
      }
      .vip-row:hover > td {
        background-color: #fff3cc !important;
      }
    */}
  </>;
}

export default Depot;